window.addEventListener('pagehide', () => {
   // On ne supprime que si on n'est pas en train de valider le panier
   // (pour éviter de vider le cache juste avant la redirection panier)
   if (!window.isSubmittingPayload) {
       localStorage.removeItem('album_draft');
   }
});

document.addEventListener('alpine:init', () => {
    Alpine.data('albumCreator', (config = {}) => ({
        photos: Array.from({ length: config.totalPhotos }, (_, i) => ({ id: Date.now() + i, url: null })),
        isDragging: false,
        uploadingCount: 0,
        step: 1,
        uploading: false,
        loading: false,
        progress: 0,
        error: '',
        editKey: new URLSearchParams(window.location.search).get('edit_line_item'), // Récupère la clé du produit à éditer
        allVariants: JSON.parse(document.getElementById('product-variants-json').innerHTML),
        workerUrl: "https://upload-bobidibook.jjollant.workers.dev",
        // --- DONNÉES DU FORMULAIRE ---
        form: {
            titre: '',
            photoFile: null,
            coverFile: null,
            prenom: '', // Persistance prénom
            choixTexte: '', // 'option1', 'option2' ou 'custom'
            optionSelectionnee:'',
            textePerso: '',
            vernis: 'non', // Valeur par défaut
            exemplaire: '1',
            currentOrder:null,
        },
        coverFileName: '',
        photoFileName: '',

        async init() {
            const savedState = localStorage.getItem('album_draft');
            if (savedState) {
                const data = JSON.parse(savedState);
                // On fusionne les données sauvegardées dans le formulaire
                this.form = { ...this.form, ...data };
            }

            // 2. Écouter les changements pour sauvegarder en temps réel
            this.$watch('form', (value) => {
                localStorage.setItem('album_draft', JSON.stringify(value));
            }, { deep: true });
            this.$watch('form.optionSelectionnee', () => this.updateFinalText());
            if (this.editKey) {
                this.loading = true;
                try {
                    const res = await fetch('/cart.js');
                    const cart = await res.json();
                    const item = cart.items.find(i => i.key === this.editKey);

                    if (item) {
                        // Pré-remplissage du formulaire avec les propriétés existantes
                        this.form.titre = item.properties['Titre'] || '';
                        this.form.prenom = item.properties['Prénom'] || '';
                        this.form.vernis = item.properties['Vernis'] || 'non';
                        this.form.currentOrder = item.properties['_order'];
                        this.form.optionSelectionnee = item.properties['_Texte']
                        const textePanier = item.properties['Texte'] || '';
                    
                        this.form.choixTexte = textePanier;
                        this.form.textePerso = item.properties['Mot personnalisé'] || '';
                        this.form.exemplaire = item.properties['Nombre d\'exemplaires']
                        this.form.photoFile = item.properties['Photo importée'] || '';
                        this.form.coverFile = item.properties['_Couverture'] || '';

                        const photosTrouvees = {};
                        Object.keys(item.properties['_Pages']).forEach(key => {
                                photosTrouvees[key] = item.properties['_Pages'][key];
                            
                        });

                        // On met à jour notre tableau local this.photos
                        // On boucle sur le tableau existant (24 slots) pour ne pas casser la structure
                        this.photos = this.photos.map((slot, i) => {
                            if (photosTrouvees[i]) {
                                return {
                                    ...slot,
                                    url: photosTrouvees[i]
                                };
                            }
                            return slot;
                        });

                    }
                } catch (e) {
                    console.error("Erreur lors de la récupération de l'article", e);
                } finally {
                    this.loading = false;
                }
            }
        },
       handleSort(item, position) {
           
            const fromIndex = this.photos.findIndex(p => p.id == item);
            const toIndex = position;

            if (fromIndex === toIndex) return;

            // 2. On déplace l'élément dans le tableau
            const element = this.photos.splice(fromIndex, 1)[0];
            this.photos.splice(toIndex, 0, element);

            // 3. LE FIX : On crée une nouvelle référence de tableau
            // Cela force Alpine à "voir" que toute la liste a changé
            const newOrder = [...this.photos];
            this.photos = []; // On vide temporairement (invisible à l'oeil nu)
            
            this.$nextTick(() => {
                this.photos = newOrder; // On réinjecte le tableau trié
            });
        },
        // Gestion du lâcher de fichiers sur la grille
        async handleFileDrop(event) {
            this.isDragging = false;
            const files = Array.from(event.dataTransfer.files);
            this.processFiles(files);
        },
        // Fonction commune pour traiter une liste de fichiers
        async processFiles(files) {
            for (const file of files) {
                const emptyIndex = this.photos.findIndex(p => p.url === null);
                if (emptyIndex === -1) break; // Plus de place

                // Ton upload Cloudflare ici
                const url = await this.uploadToCloudflare(file);
                this.photos[emptyIndex].url = url;
            }
        },
        // Appeler cette fonction une fois la commande ajoutée au panier
        clearDraft() {
            localStorage.removeItem('selectedProduct');
            localStorage.removeItem('album_draft');
        },
        updateFinalText() {
            const p = this.form.prenom || "...";
            if (this.form.optionSelectionnee === 'option1') {
                this.form.choixTexte = window.albumSettings.opt1.replace("[prénom]", p);
            } else if (this.form.optionSelectionnee === 'option2') {
                this.form.choixTexte = window.albumSettings.opt2.replace("[prénom]", p);
            } else if (this.form.optionSelectionnee === 'custom') {
                this.form.choixTexte = this.form.optionSelectionnee;
            }
        },
       get currentVariant() {
            return this.allVariants.find(variant => {
                // On vérifie que l'option1 est "1" ET que l'option2 match le choix du vernis
                return variant.option1 === this.form.exemplaire && 
                    variant.option2.toLowerCase() === this.form.vernis.toLowerCase();
            });
        },
        // --- ÉTAPE 1 : VALIDATION ---
        validateStep1() {
            if (!this.form.titre.trim()) {
                this.error = "Le titre est obligatoire.";
                return;
            }
            this.error = '';
            this.step = 2;
        },
        validateStep2() {
            if (this.form.photoFile || (this.editKey && this.form.oldCoverUrl)) {
                this.error = '';
                this.step = 3;
            } else {
                this.error = "Veuillez importer une photo.";
            }
        },
        // --- HELPER : Remplacement dynamique du prénom ---
        formatText(template) {
            // Remplace [prénom] par la valeur de l'input ou par un défaut
            const nom = this.form.prenom.trim() !== '' ? this.form.prenom : "[Prénom de l'enfant]";
            // Gère ton ancien format "[prénom de l’enfant]" et le nouveau "[prénom]"
            let text = template.replace(/\[.*?\]/g, nom);
            return text;
        },

        // --- VALIDATION ÉTAPE 3 ---
        isStep3Valid() {
            if (!this.form.prenom.trim()) return false;
            if (!this.form.choixTexte) return false;
            if (this.form.choixTexte === 'custom' && !this.form.textePerso.trim()) return false;
            return true;
        },

        validateStep3() {
            if (!this.isStep3Valid()) {
                this.error = "Erreur de validation";
                return;
            }
            
            this.error = '';
            this.step = 4; // Vers l'étape suivante (Grid 24 photos)
        },

        validateStep4() {
           // 1. Vérification de la couverture
            if (!this.form.coverFile) {
                  this.error =  "Veuillez ajouter une photo de couverture pour votre album.";
                return false;
            }

            // 2. Vérification des photos intérieures
            // On filtre le tableau pour ne garder que celles qui ont une URL
            const uploadedPhotos = this.photos.filter(p => p.url !== null && p.url !== '');
            if (uploadedPhotos.length < this.photos.length) {
                  this.error = `Il manque ${this.photos.length - uploadedPhotos.length} photo(s) dans votre album.`;
                return false;
            }
            this.step = 5;
        },
        async uploadSingle(event, index) {
            const file = event.target.files[0];
            if (!file) return;

            // On peut ajouter un état visuel local si tu veux
            // this.photos[index].uploading = true; 

            try {
                // Utilise ta fonction Cloudflare existante
                const publicUrl = await this.uploadToCloudflare(file);
                
                // On met à jour l'URL à l'index précis
                this.photos[index].url = publicUrl;
                
                // Petit trick pour forcer Alpine à voir le changement si besoin
                this.photos = [...this.photos];

            } catch (err) {
                console.error("Erreur slot " + index, err);
                alert("Erreur lors de l'upload.");
            } finally {
                // Reset de l'input pour permettre de re-sélectionner le même fichier
                event.target.value = '';
            }
        },
        async handleSmartUpload(event, startIndex) {
            const files = Array.from(event.target.files);
            if (files.length === 0) return;

            this.loading = true;

            for (let i = 0; i < files.length; i++) {
                const targetIndex = startIndex + i;

                // On vérifie qu'on ne dépasse pas la limite de 24 (ou la taille du tableau)
                if (targetIndex < this.photos.length) {
                    try {
                        const file = files[i];
                        const publicUrl = await this.uploadToCloudflare(file);
                        
                        // On remplit la case actuelle ou la suivante
                        this.photos[targetIndex].url = publicUrl;
                        
                        // Mise à jour réactive
                        this.photos = [...this.photos];
                    } catch (err) {
                        console.error(`Erreur upload fichier ${i}:`, err);
                    }
                }
            }

            this.loading = false;
            event.target.value = ''; // Reset pour permettre de re-sélectionner
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.uploading = true;
            this.uploadProgress = 0;

            try {
                // 1. Compression (Optionnel mais recommandé)
                
                // 2. Upload vers Cloudflare (ta fonction existante)
                const publicUrl = await this.uploadToCloudflare(file);
                
                // 3. On enregistre l'URL finale immédiatement
                this.form.photoFile = publicUrl;
                
                // On sauvegarde dans le localStorage au cas où il change de page
                localStorage.setItem('album_draft', JSON.stringify(this.form));

            } catch (err) {
                alert("Erreur lors de l'upload : " + err.message);
            } finally {
                this.uploading = false;
            }
        },
        async handleCoverUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.uploading = true;
            this.uploadProgress = 0;

            try {
                // 1. Compression (Optionnel mais recommandé)
                
                // 2. Upload vers Cloudflare (ta fonction existante)
                const publicUrl = await this.uploadToCloudflare(file);
                
                // 3. On enregistre l'URL finale immédiatement
                this.form.coverFile = publicUrl;
                
                // On sauvegarde dans le localStorage au cas où il change de page
                localStorage.setItem('album_draft', JSON.stringify(this.form));

            } catch (err) {
                alert("Erreur lors de l'upload : " + err.message);
            } finally {
                this.uploading = false;
            }
        },
        removeImage() {
            this.form.photoFile = '';
            if (this.$refs.photoInput) {
                this.$refs.photoInput.value = '';
            }
        },

        removeCover() {
            this.form.coverFile = '';
            if (this.$refs.coverInput) {
                this.$refs.coverInput.value = '';
            }
        },
        removePhoto(index) {
            this.photos[index].url = null;
        },
        async uploadToCloudflare(file) {
            try {
                // 1. On demande les URLs au Worker (POST)
                const getUrlResponse = await fetch(this.workerUrl, {
                    method: 'POST',
                    body: JSON.stringify({ 
                        fileName: `${Date.now()}-${file.name}`,
                        contentType: file.type 
                    })
                });
                
                const { uploadUrl, publicUrl } = await getUrlResponse.json();

                // 2. On envoie physiquement le fichier au Worker (PUT)
                const uploadRes = await fetch(uploadUrl, {
                    method: 'PUT',
                    body: file,
                    headers: { 'Content-Type': file.type }
                });

                if (!uploadRes.ok) throw new Error("Échec du transfert vers R2");
                return publicUrl; // C'est l'URL qu'on stockera dans les propriétés Shopify
            } catch (err) {
                console.error("Erreur Cloudflare:", err);
                throw err;
            }
        },

        // --- NAVIGATION ---
        prev() {
            this.error = '';
            if (this.step > 1) this.step--;
        },
        async submitToCart() {
            window.isSubmittingPayload = true;
            if (!this.currentVariant) {
                this.error = "Veuillez sélectionner une option.";
                return;
            }

            this.loading = true;

            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            if(!this.form.currentOrder) {
                this.form.currentOrder = cart.items.length + 1;
            }
            let formData = new FormData();
            // On utilise l'ID trouvé dynamiquement !
            formData.append('id', this.currentVariant.id);
            formData.append('quantity', 1);
            
            // On ajoute les propriétés de personnalisation (Properties)
            formData.append('properties[Titre]', this.form.titre);
            formData.append('properties[Prénom]', this.form.prenom);
            formData.append('properties[_Texte]', this.form.optionSelectionnee);
            formData.append('properties[Texte]', this.form.choixTexte);
            if(this.form.textePerso && this.form.choixTexte === "custom")
            {
                formData.append('properties[Mot personnalisé]', this.form.textePerso);
            }
            formData.append("properties[Nombre d'exemplaires]", this.form.exemplaire);
            formData.append("properties[Vernis]", this.form.vernis);
            formData.append('properties[_order]', this.form.currentOrder);
            formData.append('properties[Photo importée]', this.form.photoFile);
            let url = '/pages/infos-pratiques';
            if(this.form.coverFile) {
                formData.append('properties[_Couverture]', this.form.coverFile);
                url = '/cart'; 
            }
            this.photos
            .filter(photo => photo.url) // On ne garde que celles qui existent
            .forEach((photo, i) => {
                formData.append(`properties[_Pages][]`, photo.url);
            });
            
            try {
                if (this.editKey) {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: this.editKey, quantity: 0 })
                    });
                }
                const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
                this.clearDraft();
                if (res.ok) window.location.href = url;
            } catch (err) {
                this.error = "Erreur lors de l'ajout au panier.";
            } finally {
                this.loading = false;
            }
        }
    }));
});